import { MOKA_GOAUTH_SERVICE } from 'api/constants';

const SHOP_EXT_SERVICE = `${MOKA_GOAUTH_SERVICE}/shop-ext`;

export function shopById(shopId) {
  return `${SHOP_EXT_SERVICE}/v1/shops/${shopId}`;
}

export function outletById(outletId) {
  return `${SHOP_EXT_SERVICE}/v1/outlets/${outletId}`;
}

export const GET_SHOP = `${SHOP_EXT_SERVICE}/v1/shops`;
export const CREATE_SHOP = `${SHOP_EXT_SERVICE}/v1/shops`;
export const GET_BUSINESS_INFO = `${SHOP_EXT_SERVICE}/v1/business-info`;
export const PATCH_META_TAG = `${SHOP_EXT_SERVICE}/v1/meta-tags`;
